import React from 'react';

const InputField = ({ label, type, name, value, onChange, placeholder, required, error }) => (
  <div className="mb-6">
    <label className="form-label" htmlFor={name}>
      {label} {required && <span className="text-danger">*</span>}
    </label>
    <input
      className={`form-input ${error ? 'border-red-500' : 'border-gray-300'}`}
      id={name}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
    {error && <p className="form-error">{error}</p>}
  </div>
);

export default InputField;
